import CategoryTag from "core/tags/category-tag/CategoryTag";
import InfoContext from "pages/InfoContext";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { TAG_TYPES } from "constants/constants";
import { Table } from "core/table/Table";
import { Typography } from "core/typography/Typography";
import { formatValueDate } from "utils/functions";
import { getClientName } from "utils/staffHelper";
import { useContext } from "react";
const EvaluationProject = () => {
  const { personEvaluations, clientsByIds, userScope, lang } =
    useContext(InfoContext);

  const header = [
    {
      label: {
        key: "period",
        value: <FormattedMessage id="period_label" defaultMessage="Période" />,
      },
      icon: "calendar",
      width: "13.8%",
    },
    {
      label: {
        key: "title",
        value: (
          <FormattedMessage
            id="project_title_label"
            defaultMessage="Intitulé du projet"
          />
        ),
      },
      icon: "project",
      width: "25.6%",
    },
    {
      label: {
        key: "client",
        value: <FormattedMessage id="client" defaultMessage="Client" />,
      },
      icon: "user",
      width: "20.5%",
    },
    {
      label: {
        key: "manager",
        value: <FormattedMessage id="manager" defaultMessage="Manager" />,
      },
      icon: "user",
      width: "19.4%",
    },
    {
      label: {
        key: "Date",
        value: <FormattedMessage id="date_label" defaultMessage="Date" />,
      },
      icon: "calendar",
      width: "20.6%",
    },
  ];

  const formatContent = (data) =>
    data?.map((elm) => ({
      period: (
        <>
          {elm?.start_date} à {elm?.end_date || "-"}
        </>
      ),
      title: elm?.mission_name,
      client: getClientName({ clients: clientsByIds, id: elm?.client_id }),
      manager: (
        <CategoryTag
          key={1}
          type={TAG_TYPES.PEOPLE}
          label={`${elm?.manager_first_name} ${elm?.manager_last_name}`}
          showing={true}
          many={false}
          deleteOption={false}
        />
      ),
      date: (
        <>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p> {formatValueDate({ lang, date: elm?.closed_at })} </p>
            <Link
              to={`/${userScope}/balancesheet/mission/${elm?.mission_id}/${elm?.evaluation_id}`}
              style={{ maxWidth: "132px", marginBottom: "13px" }}
            >
              <FormattedMessage
                id="see_mission_eval"
                defaultMessage="Voir l’éval. de performance"
              />
            </Link>
          </div>
        </>
      ),
    }));
  return (
    <div className="section">
      <Typography
        className="title-3 violet text-uppercase"
        type="h2"
        label={
          <FormattedMessage
            id="project_evaluation"
            defaultMessage="évaluations projets - online"
          />
        }
      />

      <div>
        <Table
          id="evaluation_project"
          header={header}
          content={formatContent(personEvaluations?.mission_evaluations) || []}
        />
      </div>
    </div>
  );
};

export default EvaluationProject;
